module.exports = JSON.parse('{"Studies":"Test Studies","Measurements":"Test Measurements"}')